<template>
  <div>
    <v-container v-if="!cotacao.fornecedores || !cotacao.fornecedores.length">
      Enviada para todos os fornecedores
    </v-container>
    <v-list class="rounded-card" v-if="fornecedores && fornecedores.length && !loading">
      <template v-for="(fornecedor, index) in fornecedores">
        <v-list-item :key="fornecedor.id">
          <v-list-item-content>
            <v-list-item-title>
              <px-indicador-resposta :situacao="fornecedor.situacaoSolicitacaoResposta"/>
              <px-span-tooltip
                v-if="fornecedor.codigoInterno"
                bottom
                text-class="caption"
                :text="`(${fornecedor.codigoInterno}) `"
                tooltip="Código interno do fornecedor"/>
              <px-span-tooltip
                bottom
                :text="fornecedorLabel(fornecedor)"
                :tooltip="fornecedor.pessoa.nome"/>
              <px-popover-fornecedor :fornecedor-id="fornecedor.id" show-score />
            </v-list-item-title>
            <v-list-item-subtitle>
              <px-fornecedor-documento :fornecedor="fornecedor"/>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="hasRoleComprador">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs"
                         v-on="on"
                         icon
                         :loading="loadingEmail"
                         :disabled="fornecedor.$enviadoEmail"
                         @click="enviarEmail(fornecedor)">
                    <v-icon color="blue lighten-2">
                      mdi-email-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>Reenviar e-mail</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs"
                        v-on="on"
                        icon
                        :loading="loadingWhatsapp"
                        :disabled="fornecedor.$enviadoWhats"
                        @click="enviarWhatsapp(fornecedor)">
                    <v-icon color="green lighten-1">
                      mdi-whatsapp
                    </v-icon>
                  </v-btn>
                </template>
                <span>Reenviar whatsapp</span>
              </v-tooltip>
            </div>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="index !== (fornecedores.length - 1)"
                   :key="`v-div-f${fornecedor.id}`"/>
      </template>
    </v-list>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { find, get, orderBy } from 'lodash';
import { DetalheFornecedorUtils } from 'px-components';
import RespostaService from '../resposta-service';

export default {
  props: {
    solicitacoes: Array,
    cotacao: {
      type: Object,
      required: true,
    },
    enviadoTodosWhats: Boolean,
    enviadoTodosEmail: Boolean,
  },
  data() {
    return {
      loading: false,
      loadingEmail: false,
      loadingWhatsapp: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    fornecedores() {
      let { fornecedores } = this.cotacao;
      if (this.solicitacoes && this.solicitacoes.length) {
        fornecedores = this.buildFornecedores(fornecedores);
      }
      return fornecedores;
    },
    fornecedorLabel() {
      return fornecedor => Vue.filter('truncate')(fornecedor.pessoa.nome, 30);
    },
  },
  methods: {
    buildFornecedor(fornecedorToBuild) {
      const fornecedor = { ...fornecedorToBuild };
      const { detalhesFornecedores } = this.cotacao;
      const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);

      fornecedor.situacaoSolicitacaoResposta = get(find(this.solicitacoes, { fornecedor: { id: fornecedor.id } }), 'situacaoSolicitacaoResposta');
      fornecedor.$enviadoWhats = this.enviadoTodosWhats;
      fornecedor.$enviadoEmail = this.enviadoTodosEmail;
      fornecedor.codigoInterno = detalhe.codigoInterno;
      fornecedor.pessoa.nome = detalhe.nome || fornecedor.pessoa.nome;
      return fornecedor;
    },
    buildFornecedores(fornecedores) {
      return orderBy(fornecedores.map(f => this.buildFornecedor(f)), ['pessoa.nome'], ['asc']);
    },
    enviarEmail(fornecedor) {
      this.loadingEmail = true;

      const solicitacaoFornecedor = this.solicitacoes
        .find(solicitacao => solicitacao.fornecedor.id === fornecedor.id);
      RespostaService.enviarEmail(this.cotacao.id, solicitacaoFornecedor.id)
        .then(() => {
          this.$toast('E-mail reenviado com sucesso!', { color: 'success' });
          // eslint-disable-next-line no-param-reassign
          fornecedor.$enviadoEmail = true;
        })
        .finally(() => {
          this.loadingEmail = false;
        });
    },
    enviarWhatsapp(fornecedor) {
      this.loadingWhatsapp = true;

      const solicitacaoFornecedor = this.solicitacoes
        .find(solicitacao => solicitacao.fornecedor.id === fornecedor.id);
      RespostaService.enviarWhatsapp(this.cotacao.id, solicitacaoFornecedor.id)
        .then(() => {
          this.$toast('Whatsapp reenviado com sucesso!', { color: 'success' });
          // eslint-disable-next-line no-param-reassign
          fornecedor.$enviadoWhats = true;
        })
        .finally(() => {
          this.loadingWhatsapp = false;
        });
    },
  },
};
</script>
